"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC20 = exports.ERC1155 = exports.ERC721 = void 0;
// TOKEN STANDARDS
exports.ERC721 = 'ERC721';
exports.ERC1155 = 'ERC1155';
exports.ERC20 = 'ERC20';
//# sourceMappingURL=constants.js.map